import React from 'react';
import routes from 'js/core_pre_webpack/routes';
import styled from 'astroturf/react';
import { $image_url } from 'js/utils';
import CoralNewUserDiscountButton from './CoralNewUserDiscountButton';
import { ImpressionWatcher } from 'js/utils/impressions';
import _PremiumButtonAnchor from "PremiumButton-PremiumButtonAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/PremiumButton.tsx?styleId=PremiumButtonAnchor";
import _Icon from "PremiumButton-Icon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/PremiumButton.tsx?styleId=Icon";


const PremiumButtonAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "PremiumButtonAnchor",
  styles: _PremiumButtonAnchor
});

const Icon = /*#__PURE__*/styled("img", null, {
  displayName: "Icon",
  styles: _Icon
});

type Props = {
  reactivate?: string;
  coupon?: string;
  coralNewUserDiscountProps?: React.ComponentProps<
    typeof CoralNewUserDiscountButton
  >;
  trialPricingCopy?: string;
};

const PremiumButton = (props: Props) => {
  let trigger = 'default';
  let url = routes.upgrade_url({
    feature: 'default',
    trigger: trigger,
    from_navbar: true,
  });
  if (props.trialPricingCopy) {
    trigger = 'nav-btn-trial';
    url = routes.checkout_url({
      feature: 'default',
      trigger: trigger,
      from_navbar: true,
    });
  } else if (props.reactivate) {
    trigger = 'nav-btn-reactivate';
    url = routes.checkout_url({
      feature: 'default',
      trigger: trigger,
      premium_discount_coupon: props.coupon,
      from_navbar: true,
    });
  }

  let ctaText = 'Premium';
  if (props.trialPricingCopy) {
    ctaText = props.trialPricingCopy;
  } else if (props.reactivate) {
    // TODO: DANGER: Claiming a specific discount without proof one exists
    ctaText = 'Reactivate Premium 50% OFF';
  } else if (props.coralNewUserDiscountProps) {
    return <CoralNewUserDiscountButton {...props.coralNewUserDiscountProps} />;
  }

  return (
    <ImpressionWatcher source={trigger}>
      <PremiumButtonAnchor href={url}>
        <Icon
          src={$image_url('premium/Lock-CircleWhite-Blue.svg')}
          alt="padlock"
        />
        {ctaText}
      </PremiumButtonAnchor>
    </ImpressionWatcher>
  );
};

export default PremiumButton;
